module.exports = __webpack_public_path__ + "img/4674-gelett-burgess-quotes.fe95decc.jpeg";